import apiClient from "../client";

// GET /api/allocation-requests
// MAC Leader auto-filtered by backend to own requests only
export const getMyAllocations = async (params = {}) => {
  const response = await apiClient.get("/allocation-requests", { params });
  return response.data;
};

// GET /api/allocation-requests/{id}
export const getAllocationById = async (id) => {
  const response = await apiClient.get(`/allocation-requests/${id}`);
  return response.data;
};

// POST /api/allocation-requests
// Body: { positionId, associateId, fte, startDate, endDate, notes, deployedSkillIds }
export const submitAllocationRequest = async (body) => {
  const response = await apiClient.post("/allocation-requests", body);
  return response.data;
};

// PATCH /api/allocation-requests/{id}
// Body: { fte, startDate, endDate, notes, deployedSkillIds }
// Only editable fields — positionId and associateId cannot change after submission
export const updateAllocationRequest = async (id, body) => {
  const response = await apiClient.patch(`/allocation-requests/${id}`, body);
  return response.data;
};

// POST /api/allocation-requests/{id}/resubmit
// Body: { fte?, startDate?, endDate?, notes? } — all optional, carry over from original if omitted
// Only callable by original MAC Leader when status === REJECTED
export const resubmitAllocationRequest = async (originalRequestId, body) => {
  const response = await apiClient.post(`/allocation-requests/${originalRequestId}/resubmit`, body);
  return response.data;
};


// POST /api/allocation-requests/{id}/amend
// Body: { fte, startDate, endDate, notes } — all required
// Only callable when status === ACTIVE
export const amendAllocationRequest = async (id, body) => {
  const response = await apiClient.post(`/allocation-requests/${id}/amend`, body);
  return response.data;
};


// POST /api/allocation-requests/{id}/end
export const endAllocation = async (requestId) => {
  const response = await apiClient.post(`/allocation-requests/${requestId}/end`);
  return response.data;
};

// DELETE /api/allocation-requests/{id} — PMO only
// Not-yet-live requests are removed outright; an ACTIVE request is released
// the same way End releases it, then marked CANCELLED.
export const deleteAllocationRequest = async (requestId) => {
  await apiClient.delete(`/allocation-requests/${requestId}`);
};



// GET /api/positions/open-for-move?type=UBL or ?type=BIL
export const getOpenPositionsForMove = async (type) => {
  const response = await apiClient.get("/positions/open-for-move", { params: { type } });
  return response.data;
};

// POST /api/allocation-requests/{sourceRequestId}/move
export const submitMoveRequest = async (sourceRequestId, body) => {
  const response = await apiClient.post(`/allocation-requests/${sourceRequestId}/move`, body);
  return response.data;
};



// GET /api/billing-exceptions/by-request/{requestId}
export const getBillingExceptions = async (requestId) => {
  const response = await apiClient.get(`/billing-exceptions/by-request/${requestId}`);
  return response.data;
};

// POST /api/billing-exceptions
export const createBillingException = async (body) => {
  const response = await apiClient.post("/billing-exceptions", body);
  return response.data;
};

// PATCH /api/billing-exceptions/{id}
export const updateBillingException = async (id, body) => {
  const response = await apiClient.patch(`/billing-exceptions/${id}`, body);
  return response.data;
};

// PATCH /api/billing-exceptions/{id}/deactivate
export const deactivateBillingException = async (id) => {
  const response = await apiClient.patch(`/billing-exceptions/${id}/deactivate`);
  return response.data;
};